document.addEventListener('DOMContentLoaded', function() {
  // Initialize the menu drawer accordion functionality
  const accordionMenuItems = document.querySelectorAll('.accordion-menu-item');
  
  // Fix icon display issues
  accordionMenuItems.forEach(item => {
    const summary = item.querySelector('summary');
    const submenu = item.querySelector('.menu-drawer__submenu');
    
    if (summary && submenu) {
      // Ensure the submenu has accordion class
      if (!submenu.classList.contains('menu-drawer__submenu--accordion')) {
        submenu.classList.add('menu-drawer__submenu--accordion');
      }
      
      // Ensure the summary has the accordion class
      if (!summary.classList.contains('menu-drawer__menu-item--accordion')) {
        summary.classList.add('menu-drawer__menu-item--accordion');
      }
      
      // Handle click event
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = item.hasAttribute('open');
        
        // Close all other open accordions first
        const otherAccordions = document.querySelectorAll('.accordion-menu-item[open]');
        otherAccordions.forEach(accordion => {
          if (accordion !== item) {
            const accordionSubmenu = accordion.querySelector('.menu-drawer__submenu');
            if (accordionSubmenu) {
              accordionSubmenu.classList.remove('is-open');
              
              // Animate submenu items out
              const menuItems = accordionSubmenu.querySelectorAll('li');
              menuItems.forEach((menuItem, index) => {
                // Remove entering class and add exiting class
                menuItem.classList.remove('menu-item-entering');
                menuItem.classList.add('menu-item-exiting');
                
                // Set submenu animation order
                menuItem.style.setProperty('--submenu-order', index + 1);
                
                // Reverse the animation order for fade out
                const delay = 0.03 * (menuItems.length - index - 1);
                menuItem.style.transitionDelay = `${delay}s`;
                menuItem.style.opacity = '0';
                menuItem.style.transform = 'translateY(8px)';
              });
              
              // After items are animated out, close the accordion
              setTimeout(() => {
                accordion.removeAttribute('open');
                
                // Clean up animation classes
                menuItems.forEach(menuItem => {
                  menuItem.classList.remove('menu-item-exiting');
                  menuItem.style.transitionDelay = '';
                });
              }, 300);
            } else {
              accordion.removeAttribute('open');
            }
          }
        });
        
        if (isOpen) {
          // Close this accordion
          // Animate items out first
          const menuItems = submenu.querySelectorAll('li');
          menuItems.forEach((menuItem, index) => {
            // Remove entering class and add exiting class
            menuItem.classList.remove('menu-item-entering');
            menuItem.classList.add('menu-item-exiting');
            
            // Set submenu animation order 
            menuItem.style.setProperty('--submenu-order', index + 1);
            
            // Reverse animation order for closing (last item first)
            const delay = 0.03 * (menuItems.length - index - 1);
            menuItem.style.transitionDelay = `${delay}s`;
            menuItem.style.opacity = '0';
            menuItem.style.transform = 'translateY(8px)';
          });
          
          // After animation completes, close the accordion
          setTimeout(() => {
            submenu.classList.remove('is-open');
            item.removeAttribute('open');
            
            // Clean up animation classes
            menuItems.forEach(menuItem => {
              menuItem.classList.remove('menu-item-exiting');
              menuItem.style.transitionDelay = '';
            });
          }, 300);
        } else {
          // Open this accordion
          item.setAttribute('open', '');
          submenu.classList.add('is-open');
          
          // Animate submenu items in with staggered delay
          const menuItems = submenu.querySelectorAll('li');
          menuItems.forEach((menuItem, index) => {
            // Set submenu animation order
            menuItem.style.setProperty('--submenu-order', index + 1);
            
            // Add entering class for CSS animations
            menuItem.classList.add('menu-item-entering');
            
            // Reset opacity and transform for animation
            menuItem.style.opacity = '0';
            menuItem.style.transform = 'translateY(8px)';
            
            // Set delay based on index for staggered animation
            const delay = 0.05 * (index + 1);
            menuItem.style.transitionDelay = `${delay}s`;
            
            // Trigger reflow to ensure animation works
            void menuItem.offsetWidth;
            
            // Animate in
            menuItem.style.opacity = '1';
            menuItem.style.transform = 'translateY(0)';
          });
          
          // Clean up animation classes after animations complete
          setTimeout(() => {
            menuItems.forEach(menuItem => {
              menuItem.style.transitionDelay = '';
            });
          }, 600);
        }
      });
    }
  });
  
  // Initialize slider functionality
  const sliderContainer = document.querySelector('.menu-drawer__slider-container');
  if (sliderContainer) {
    // Make sure it's visible with animation
    sliderContainer.style.display = 'block';
    
    // Animate slider items with staggered effect
    const sliderItems = document.querySelectorAll('.menu-drawer__slider-item');
    sliderItems.forEach((item, index) => {
      // Set animation order based on index
      item.style.setProperty('--slider-item-order', index + 1);
    });
  }
  
  // Handle menu drawer opening
  const menuDrawer = document.querySelector('#Details-menu-drawer-container');
  const menuDrawerContent = document.querySelector('#menu-drawer');
  
  if (menuDrawer) {
    menuDrawer.addEventListener('toggle', function() {
      const isOpen = this.hasAttribute('open');
      
      if (isOpen) {
        // When opening the drawer
        document.body.classList.add('overflow-hidden-mobile');
        
        // Make sure menu drawer has proper opening class
        this.classList.add('menu-opening');
        
        // Animate the inner container
        const innerContainer = menuDrawerContent.querySelector('.menu-drawer__inner-container');
        if (innerContainer) {
          innerContainer.style.opacity = '0';
          innerContainer.style.transform = 'translateY(20px)';
          
          // Trigger reflow to ensure animation works
          void innerContainer.offsetWidth;
          
          innerContainer.style.opacity = '1';
          innerContainer.style.transform = 'translateY(0)';
        }
        
        // Animate all menu items
        const menuItems = menuDrawerContent.querySelectorAll('.menu-drawer__navigation ul li');
        menuItems.forEach((item, index) => {
          // Set animation order for staggered effect
          item.style.setProperty('--animation-order', index + 1);
          
          // Ensure proper animation class is applied
          item.classList.add('menu-item-entering');
        });
        
        // Animate slider if it exists
        if (sliderContainer) {
          sliderContainer.style.opacity = '0';
          sliderContainer.style.transform = 'translateY(10px)';
          
          // Trigger reflow
          void sliderContainer.offsetWidth;
          
          // Animate in with slight delay
          setTimeout(() => {
            sliderContainer.style.opacity = '1';
            sliderContainer.style.transform = 'translateY(0)';
            
            // Animate individual slider items
            const sliderItems = sliderContainer.querySelectorAll('.menu-drawer__slider-item');
            sliderItems.forEach((item, index) => {
              // Initial state
              item.style.opacity = '0';
              item.style.transform = 'translateY(10px)';
              
              // Staggered animation
              setTimeout(() => {
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
              }, 50 + (index * 50));
            });
          }, 150);
        }
      } else {
        // When closing the drawer
        document.body.classList.remove('overflow-hidden-mobile');
        this.classList.remove('menu-opening');
        
        // Close all open accordions before closing the drawer
        const openAccordions = menuDrawerContent.querySelectorAll('.accordion-menu-item[open]');
        openAccordions.forEach(accordion => {
          const accordionSubmenu = accordion.querySelector('.menu-drawer__submenu');
          if (accordionSubmenu) {
            accordionSubmenu.classList.remove('is-open');
            accordion.removeAttribute('open');
          }
        });
        
        // Fade out animation
        if (menuDrawerContent) {
          menuDrawerContent.style.opacity = '0';
          
          // Reset styles after transition
          setTimeout(() => {
            menuDrawerContent.style.opacity = '';
            
            // Reset any animation states
            const menuItems = menuDrawerContent.querySelectorAll('.menu-drawer__navigation ul li');
            menuItems.forEach(item => {
              item.classList.remove('menu-item-entering');
              item.classList.remove('menu-item-exiting');
            });
          }, 400);
        }
      }
    });
  }
  
  // Add hover effects to menu items
  const menuItems = document.querySelectorAll('.menu-drawer__menu-item');
  menuItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      item.style.transform = 'translateX(5px)';
    });
    
    item.addEventListener('mouseleave', () => {
      item.style.transform = 'translateX(0)';
    });
  });
}); 